import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Button,
  CardMedia,
  Rating,
  Chip,
  Checkbox,
  TextField,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close,
  Add,
  Remove,
  AccessTime,
  Favorite,
  FavoriteBorder,
} from "@mui/icons-material";

const MenuItemModal = ({
  item,
  open,
  onClose,
  onAddToCart,
  viewOnly = false,
  selectedSize: externalSelectedSize,
  selectedAddons: externalSelectedAddons,
  quantity: externalQuantity,
  specialInstructions: externalSpecialInstructions,
  onSizeChange,
  onAddonsChange,
  onQuantityChange,
  onSpecialInstructionsChange,
}) => {
  const [localSelectedSize, setLocalSelectedSize] = useState(null);
  const [localSelectedAddons, setLocalSelectedAddons] = useState([]);
  const [localQuantity, setLocalQuantity] = useState(1);
  const [localSpecialInstructions, setLocalSpecialInstructions] = useState("");
  const [isFavorite, setIsFavorite] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  // Use external state if provided, otherwise use local state
  const selectedSize = externalSelectedSize !== undefined ? externalSelectedSize : localSelectedSize;
  const selectedAddons = externalSelectedAddons !== undefined ? externalSelectedAddons : localSelectedAddons;
  const quantity = externalQuantity !== undefined ? externalQuantity : localQuantity;
  const specialInstructions = externalSpecialInstructions !== undefined ? externalSpecialInstructions : localSpecialInstructions;

  // console.log("Selected Size => ", selectedSize)
  // Handler functions that use external callbacks if provided
  const handleSizeChange = (size) => {
    // If clicking the same size that's already selected, unselect it
    // console.log("Size Change => ", size);
    // console.log("Current selectedSize => ", selectedSize);

    // Check if this size is currently selected
    const isCurrentlySelected = selectedSize?.name === size?.name;

    // If it's the same size, unselect (pass null), otherwise select the new size
    const newSize = isCurrentlySelected ? null : size;

    if (onSizeChange && item) {
      onSizeChange(newSize);
    } else {
      setLocalSelectedSize(newSize);
    }
  };

  const handleAddonChange = (addon, checked) => {
    // console.log("Add on Change")
    let newAddons;
    if (checked) {
      newAddons = [...selectedAddons, { ...addon, quantity: 1 }];
    } else {
      newAddons = selectedAddons.filter((a) => a.name !== addon.name);
    }

    if (onAddonsChange && item) {
      // console.log("Yes Here it goes to")
      onAddonsChange(newAddons);
    } else {
      setLocalSelectedAddons(newAddons);
    }
  };

  const handleAddonQuantityChange = (addonName, newQuantity) => {
    let newAddons;
    if (newQuantity <= 0) {
      newAddons = selectedAddons.filter((a) => a.name !== addonName);
    } else {
      newAddons = selectedAddons.map((a) =>
        a.name === addonName ? { ...a, quantity: newQuantity } : a
      );
    }

    if (onAddonsChange && item) {
      onAddonsChange(newAddons);
    } else {
      setLocalSelectedAddons(newAddons);
    }
  };

  const handleQuantityChange = (newQuantity) => {
    if (onQuantityChange && item) {
      onQuantityChange(newQuantity);
    } else {
      setLocalQuantity(newQuantity);
    }
  };

  const handleSpecialInstructionsChange = (instructions) => {
    if (onSpecialInstructionsChange && item) {
      onSpecialInstructionsChange(instructions);
    } else {
      setLocalSpecialInstructions(instructions);
    }
  };

  // Initialize external state when modal opens with a new item
  // useEffect(() => {
  //   if (item && open) {
  //     // If using external state management and no size is selected, set the default
  //     if (onSizeChange && !selectedSize) {
  //       const defaultSize = item.sizes_with_prices?.find((size) => size.is_default) || null;
  //       if (defaultSize) {
  //         onSizeChange(defaultSize);
  //       }
  //     }
  //     // If using local state, reset to defaults
  //     else if (!onSizeChange) {
  //       const defaultSize = item.sizes_with_prices?.find((size) => size.is_default) || null;
  //       setLocalSelectedSize(defaultSize);
  //       setLocalSelectedAddons([]);
  //       setLocalQuantity(1);
  //       setLocalSpecialInstructions("");
  //     }
  //   }
  // }, [item, open, onSizeChange, selectedSize]);
  // Initialize state when modal opens with a new item
  // useEffect(() => {
  //   if (item && open) {
  //     // If using external state management and no size is selected yet
  //     if (onSizeChange && !selectedSize) {
  //       // Only set default size if no size is already selected (no last selection)
  //       const defaultSize = item.sizes_with_prices?.find((size) => size.is_default) || null;
  //       if (defaultSize) {
  //         onSizeChange(defaultSize);
  //       }
  //     }
  //     // If using local state and no size is selected yet
  //     else if (!onSizeChange && !localSelectedSize) {
  //       const defaultSize = item.sizes_with_prices?.find((size) => size.is_default) || null;
  //       if (defaultSize) {
  //         setLocalSelectedSize(defaultSize);
  //       }
  //     }
  //     // Reset other states
  //     if (!onAddonsChange && localSelectedAddons.length === 0) {
  //       setLocalSelectedAddons([]);
  //     }
  //     if (!onQuantityChange && localQuantity === 1) {
  //       setLocalQuantity(1);
  //     }
  //     if (!onSpecialInstructionsChange && !localSpecialInstructions) {
  //       setLocalSpecialInstructions("");
  //     }
  //   }
  // }, [item, open, onSizeChange, selectedSize, localSelectedSize, localSelectedAddons, localQuantity, localSpecialInstructions, onAddonsChange, onQuantityChange, onSpecialInstructionsChange]);

  if (!item) return null;

  const calculateTotalPrice = (flag) => {
    let price = item?.base_price || 0;

    if (selectedSize) price = price + (selectedSize.price_modifier || 0);
   
    if (flag) {
      if (item?.discount_enabled && item?.discount_percentage > 0) {
        price = price * (1 - item.discount_percentage / 100);
      }
    }

     if (selectedAddons?.length) {
      price += selectedAddons.reduce(
        (sum, addon) => sum + (addon?.price || 0) * (addon?.quantity || 1),
        0
      );
    }

    console.log("Price + quantity => ", price * quantity)

    return price * quantity;
  };

  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart(
        item,
        quantity,
        selectedAddons,
        specialInstructions,
        selectedSize
      );
    }
    onClose();
  };

  const totalPrice = calculateTotalPrice(true);
  const basePrice = calculateTotalPrice(false);
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 1,
          maxHeight: isMobile ? "100vh" : "90vh",
          height: isMobile ? "100%" : "auto",
          margin: isMobile ? 0 : 2,
          boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogContent
        sx={{ p: 0, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header Image Section */}
        <Box sx={{ position: "relative", flexShrink: 0 }}>
          <CardMedia
            component="img"
            height={isMobile ? 240 : 280}
            image={
              item?.image_url ||
              "https://via.placeholder.com/400x300?text=Food+Item"
            }
            alt={item?.name}
            sx={{ objectFit: "cover" }}
          />

          {/* Gradient Overlay */}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "50%",
              background:
                "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
            }}
          />

          {/* Close Button */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              bgcolor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              "&:hover": { bgcolor: "white", transform: "scale(1.05)" },
              transition: "all 0.2s",
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <Box
          sx={{
            p: { xs: 2.5, sm: 3 },
            overflowY: "auto",
            flexGrow: 1,
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
          }}
        >
          {/* Item Title and Info */}
          <Box sx={{ mb: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "1rem !important",
                      sm: "1.25rem !important",
                      md: "1.5rem !important",
                      lg: "1.75rem !important",
                    },
                    textAlign: "left",
                    color: "#680000",
                    fontWeight: 600,
                    flex: 1,
                    pr: 1,
                  }}
                >
                  {item?.name}
                </Typography>

                <Box
                  sx={{
                    width: { xs: 14, sm: 16 },
                    height: { xs: 14, sm: 16 },
                    border: `2px solid ${item.is_veg ? "#006400" : "#8B0000"}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "2px",
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 6, sm: 8 },
                      height: { xs: 6, sm: 8 },
                      borderRadius: "50%",
                      bgcolor: item.is_veg ? "#228B22" : "#B22222",
                    }}
                  />
                </Box>
              </Box>
              {item?.is_spicy && (
                <Chip
                  label="🌶️ Spicy"
                  size="small"
                  variant="outlined"
                  sx={{
                    borderColor: "#680000",
                    color: "#680000",
                    fontSize: {
                      xs: "0.8rem !important",
                      sm: "0.85rem !important",
                      md: "0.9rem !important",
                    },
                    height: { xs: 28, sm: 32 },
                    fontWeight: 500,
                    px: 1,
                    borderWidth: 1.5,
                    backgroundColor: "#FFF0F0",
                  }}
                />
              )}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2.5,
                mb: 1,
                flexWrap: "wrap",
                mt: 0.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Rating
                  value={item?.rating || 4.5}
                  readOnly
                  size="small"
                  precision={0.1}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="500"
                  sx={{ ml: 0.5 }}
                >
                  {item?.rating || 4.5}
                </Typography>
              </Box>
            </Box>

            {/* <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 1, lineHeight: 1.7, fontSize: "16px !important" }}
            >
              {item?.description || "No Description Available"}
            </Typography> */}
          </Box>

          {/* Size Selection */}
          {/* Size Selection */}
          {item?.sizes_with_prices && item.sizes_with_prices.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                fontWeight="700"
                sx={{
                  mb: 1,
                  color: "text.primary",
                  fontSize: "14px !important",
                }}
              >
                Size
              </Typography>

              {/* Outer box containing all size options */}
              <Box
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: 1,
                  overflow: "hidden",
                  bgcolor: "white",
                }}
              >
                {item.sizes_with_prices.map((size, index) => {
                  const isSelected = selectedSize?.name === size?.name;
                  // console.log("Selected Size => ", selectedSize?.name, " = ", size?.name);
                  const isLast = index === item.sizes_with_prices.length - 1;

                  return (
                    <Box
                      key={size?.id}
                      onClick={() => handleSizeChange(size)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 2,
                        py: 1.5,
                        cursor: "pointer",
                        borderBottom: isLast ? "none" : "1px solid #E0E0E0",
                        bgcolor: isSelected ? "#FFF8F7" : "white",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          bgcolor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                      >
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleSizeChange(size)}
                          sx={{
                            color: "#680000",
                            "&.Mui-checked": { color: "#680000" },
                            p: 0,
                          }}
                        />
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {size?.name}
                          </Typography>
                        </Box>
                      </Box>

                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 700,
                          color: isSelected ? "#680000" : "text.primary",
                        }}
                      >
                        +  S${size?.price_modifier?.toFixed(2) || "0.00"}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>

            </Box>
          )}

          {/* Add-ons Selection */}
          {item?.addons_with_details && item.addons_with_details.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                fontWeight="700"
                sx={{
                  mb: 1,
                  color: "text.primary",
                  fontSize: "14px !important",
                }}
              >
                Add-ons
              </Typography>

              {/* Outer box for all add-ons */}
              <Box
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: 1,
                  overflow: "hidden",
                  bgcolor: "white",
                }}
              >
                {item.addons_with_details.map((addon, index) => {
                  const isSelected = selectedAddons.some(
                    (a) => a.name === addon.name
                  );
                  const selectedAddon = selectedAddons.find(
                    (a) => a.name === addon.name
                  );
                  const addonQuantity = selectedAddon?.quantity || 0;
                  const isLast = index === item.addons_with_details.length - 1;

                  return (
                    <Box
                      key={addon?.name}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 2,
                        py: 1.5,
                        cursor: "pointer",
                        borderBottom: isLast ? "none" : "1px solid #E0E0E0",
                        bgcolor: isSelected ? "#FFF8F7" : "white",
                        transition: "all 0.2s ease",
                        "&:hover": { bgcolor: "rgba(25, 118, 210, 0.08)" },
                      }}
                      onClick={() => handleAddonChange(addon, !isSelected)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          onChange={(e) =>
                            handleAddonChange(addon, e.target.checked)
                          }
                          size="small"
                          sx={{
                            color: "#680000",
                            "&.Mui-checked": { color: "#680000" },
                            p: 0,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: isSelected ? 600 : 500,
                              mb: addon?.description ? 0.3 : 0,
                            }}
                          >
                            {addon?.name}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          flexShrink: 0,
                        }}
                      >
                        <Typography
                          variant="body1"
                          color={isSelected ? "#680000" : "text.primary"}
                          fontWeight="700"
                        >
                          + S${addon?.price?.toFixed(2) || "0.00"}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}

          {/* Special Instructions */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="subtitle2"
              fontWeight="700"
              sx={{ mb: 1, color: "text.primary", fontSize: "14px !important" }}
            >
              Special Instructions
            </Typography>
            <TextField
              fullWidth
              placeholder="E.g., No onions, extra spicy, light oil..."
              multiline
              rows={3}
              value={specialInstructions}
              onChange={(e) => handleSpecialInstructionsChange(e.target.value)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                  bgcolor: "white",
                  "& fieldset": { borderColor: "grey.300", borderWidth: "1px" },
                  "&:hover fieldset": { borderColor: "primary.light" },
                  "&.Mui-focused fieldset": {
                    borderColor: "primary.main",
                    borderWidth: "2px",
                  },
                },
              }}
            />
          </Box>
        </Box>

        {/* Fixed Bottom Button */}
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            pt: 2,
            borderTop: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
            flexShrink: 0,
          }}
        >
          {viewOnly ? (
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="body1"
                fontWeight="600"
                color="primary.main"
                gutterBottom
              >
                🛍️ Choose Delivery or Takeaway to Order
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visit our Delivery or Takeaway sections to add this item
              </Typography>
            </Box>
          ) : (
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={handleAddToCart}
              sx={{
                borderRadius: 2.5,
                textTransform: "none",
                fontWeight: 700,
                py: 1.8,
                fontSize: "17px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                background: "#680000",
                "&:hover": {
                  boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                  transform: "translateY(-2px)",
                  background: "#680000",
                },
                transition: "all 0.3s ease-in-out",
              }}
            >
              🛒 Add to Cart  •   {(item.discount_enabled) && <span style={{ textDecoration: "line-through", marginLeft: 8, marginRight: 6 }}>
                S${basePrice.toFixed(2)}
              </span>}
              <span>S${totalPrice.toFixed(2)}</span>
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MenuItemModal;